import merge from 'lodash/merge'
import cloneDeep from 'lodash/cloneDeep'

import { XYChartController } from './xy_chart_component_controller'
import { BaseChartController, tooltipSeriesValue, tooltipValueFormatter } from './base_chart_component_controller'

export class BarChartController extends XYChartController {
  static values = merge(cloneDeep(BaseChartController.values), {
    xAxisCategories: Array
  })

  seriesType () {
    return 'bar'
  }

  axisTypes () {
    return merge(super.axisTypes(), {
      category: {
        type: 'category',
        boundaryGap: true,
        data: this.xAxisCategories,
        axisLabel: {
          interval: 0,
          overflow: 'break',
          showMinLabel: true,
          showMaxLabel: true,
          hideOverlap: false
        }
      }
    })
  }

  tooltipSeriesFormatters () {
    return merge(super.tooltipSeriesFormatters(), {
      diff: (params) => this.tooltipDiffSeriesFormatter(params),
      diff_with_full_rent_increase: (params) => this.tooltipDiffWithFullRentIncreaseSeriesFormatter(params)
    })
  }

  tooltipDiffWithFullRentIncreaseSeriesFormatter (series) {
    const config = this.options().series[series.seriesIndex]?.tooltipFormatter || {}
    const fullPercentage = series.value.full_percentage

    if (fullPercentage === null || fullPercentage === undefined) {
      return this.tooltipDiffSeriesFormatter(series)
    }

    const formatter = tooltipValueFormatter(this.localeValue, config.fullPercentageFormatter || 'percentage')

    return `${this.tooltipDiffSeriesFormatter(series)}
      <div style="margin: 10px 0 0;line-height:1;">
        <span style="font-size:14px;color:#666;font-weight:400;margin-left:2px">${config.fullPercentageLabel || ''}</span>
        <span style="float:right;margin-left:20px;font-size:14px;color:#666;font-weight:900">${formatter(fullPercentage)}</span>
        <div style="clear:both"></div>
      </div>`
  }

  tooltipDiffSeriesFormatter (series) {
    const config = this.options().series[series.seriesIndex]?.tooltipFormatter || {}
    const y = tooltipValueFormatter(this.localeValue, config.yFormatter || 'value')(series.value.y)
    const diff = series.value.diff
    const diffFormatted = diff !== undefined ? tooltipValueFormatter(this.localeValue, config.diffFormatter || 'value')(diff) : undefined
    return `<div style="margin: 10px 0 0;line-height:1;">
              <div style="margin: 0px 0 0;line-height:1;">
                ${series.marker}
                <span style="font-size:14px;color:#666;font-weight:400;margin-left:2px">${series.seriesName}</span>
                <span style="float:right;margin-left:20px;font-size:14px;color:#666">
                  <span style="font-weight:900">${y}</span>
                  ${diffFormatted !== undefined ? `(${diffFormatted})` : ''}
                </span>
                <div style="clear:both"></div>
              </div>
            </div>`
  }

  tooltipHeaderFormatters () {
    return merge(super.tooltipHeaderFormatters(), {
      total: (params) => this.tooltipTotalHeaderFormatter(params)
    })
  }

  tooltipTotalHeaderFormatter (params) {
    const total = params.map((series) => { return tooltipSeriesValue(series) }).reduce((a, b) => a + b, 0)

    return `
      <div style="margin: 0px 0 0;line-height:1;">
        <span style="font-size:14px;color:#666;font-weight:400;line-height:1;">${params[0].axisValueLabel}</span>
        <span style="float:right;margin-left:20px;font-size:14px;color:#666;font-weight:900">${total}</span>
        <div style="clear:both"></div>
      </div>
    `
  }
}

export default BarChartController
